import { useTranslation } from 'react-i18next'

import { FLOATING_ELEMENT_PLACEMENT } from '../../../../../../../constants/common'
import Button, { BUTTON_HEIGHT_32 } from '../../../../../../Button'
import { QA_NAME_APPLICANT_CHECKLIST_REJECT } from '../../ApplicantDocumentChecklist.constants'
import { ApplicantDocumentChecklistAttach } from '../../ApplicantDocumentChecklistAttach'
import { ApplicantDocumentChecklistActionCell } from '../ApplicantDocumentChecklistActionCell'

import * as styles from './ApplicantDocumentChecklistRejectCell.module.css'

function ApplicantDocumentChecklistRejectCell({
  attachTooltip,
  canAttach,
  canReject,
  disabled,
  isAttaching,
  isLoading,
  isLocked,
  row,
  tooltip,
  onAttach,
  onClick,
}) {
  const { t } = useTranslation()

  return (
    <ApplicantDocumentChecklistActionCell
      className={styles.ApplicantDocumentChecklistRejectCell}
    >
      {canReject ? (
        <Button.Outlined
          isGrey
          disabled={disabled}
          height={BUTTON_HEIGHT_32}
          isLoading={isLoading}
          qaName={QA_NAME_APPLICANT_CHECKLIST_REJECT}
          text={t('RentalPortal.ApplicantDocumentRejectBtnKey')}
          tooltip={tooltip}
          tooltipPlacement={FLOATING_ELEMENT_PLACEMENT.top}
          onClick={onClick}
        />
      ) : null}
      {canAttach ? (
        <ApplicantDocumentChecklistAttach
          isAttaching={isAttaching}
          isLocked={isLocked}
          row={row}
          tooltip={attachTooltip}
          onAttach={onAttach}
        />
      ) : null}
    </ApplicantDocumentChecklistActionCell>
  )
}

export default ApplicantDocumentChecklistRejectCell
